import { API } from 'aws-amplify';
import awsConfig from 'aws-exports';

// retrieves a bundled session audio file
export function searchSessionAudio (testID) {
  let apiName = awsConfig.aws_cloud_logic_custom[1].name;
  let path = '/stream';
  let myInit = {
    headers: {'Content-Type': 'application/json'},
    queryStringParameters: {id: testID}
  };

  return API.get(apiName, path, myInit)
  .then((resp) => resp.data)
  .catch(err => {
    console.log('SEARCH Audio failed: ', err);
  });
}
